import type { Garden } from "@/types";
import { client, unwrap } from "./client";

// The garden fetch must live OUTSIDE React render: a component that suspends on
// `use(promise)` during its initial mount never commits, so a promise created in
// render (even cached in a ref) isn't preserved across the suspense retry —
// every retry makes a new pending promise and re-fetches forever. Caching it
// here keeps it stable across retries. Reset on every auth transition so the
// next login fetches its own garden rather than reusing the prior session's.
let gardenPromise: Promise<Garden> | null = null;

export function loadGardenResource(): Promise<Garden> {
  return (gardenPromise ??= unwrap(client.api.garden.$get()));
}

export function resetGardenResource(): void {
  gardenPromise = null;
}
